import script from "./BookingCardHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookingCardHeader.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__